import {
  OreButton,
  OreNavBarHeader,
  OreNavBarHeaderDivider,
  SvgNavBarHelp,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { NavbarUser, useUI } from '@/Shared/ui/navigation'
import { headerNavbarTranslation } from '@/Shared/ui/navigation/navigationTranslation'
import { useUserData } from '@/User/ui/context'
import { DropdownSearch } from '../../DropdownSearch'
import { MasterDropdownSearch } from '../../DropdownSearchMaster/MasterDropdownSearch'

const Header = (): JSX.Element => {
  const { t } = useTranslation()
  const { sidebarCollapsed, toggleSidebar } = useUI()
  const { merchantIdentity, userMultiWeb, setActiveMultiWebMerchant, merchant } = useUserData()

  const subject = t(headerNavbarTranslation.helpSubject)
  const mailTo = import.meta.env.VITE_CONTACT_EMAIL

  const canshowMasterDropdown = userMultiWeb && userMultiWeb[0] && userMultiWeb[0].isMasterGroup

  const canShowMultiwebDropdown = 
  userMultiWeb && userMultiWeb[0] && userMultiWeb[0].subItems
  ? userMultiWeb[0].subItems.length > 0 
  : false

  return (
    <OreNavBarHeader
      handleClick={toggleSidebar}
      activeBurger={sidebarCollapsed}
      titleClient={!canShowMultiwebDropdown && !canshowMasterDropdown ? merchantIdentity.name : undefined}
      subtitleClient={!canShowMultiwebDropdown && !canshowMasterDropdown ? merchantIdentity.id : undefined}
    >
      {canShowMultiwebDropdown ? 
        <DropdownSearch 
          userMultiWeb={userMultiWeb} 
          isNursery={merchant?.isNursery || false}
          setActiveMultiWebMerchant={setActiveMultiWebMerchant} 
        /> : 
        null}
      {canshowMasterDropdown ? 
        <MasterDropdownSearch 
          userMultiWeb={userMultiWeb} 
          isNursery={merchant?.isNursery || false}
          setActiveMultiWebMerchant={setActiveMultiWebMerchant} 
        /> : 
        null}
      <OreNavBarHeaderDivider>
        <OreButton
          as="a"
          href={`mailto:${mailTo}?subject=${subject}`}
          category="tertiary"
          icon={<SvgNavBarHelp />}
        >
          {t(headerNavbarTranslation.help)}
        </OreButton>
      </OreNavBarHeaderDivider>
      <NavbarUser />
    </OreNavBarHeader>
  )
}

export { Header }
